import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'subDiget' })
export class SubDigetPipe implements PipeTransform {
    transform(value: any, arg: string): any {
        value = typeof value === 'number' ? value : parseFloat(value); //确保value为数字
        value = isNaN(value) ? 0 : value;
        let parNum = parseInt(arg); //保留数位
        let flag = arg.length == parNum.toString().length ? false : true; //是否补零
        let str:any = value + ''; //
        // debugger;
        let index = str.indexOf('.') === -1 ? 0 : str.indexOf('.'); //查找小数点下标，确定位置
        if (flag) {
            //补零情况
            if (index == 0) {
                //value为整数
                str += '.';
                for (let i = 0; i < parNum; i++) {
                    str += '0';
                }
                return str;
            } else {
                //value不为整数
                let len = parNum - (str.length - (index + 1));
                if (len > 0) {
                    for (let i = 0; i < len; i++) {
                        str += '0';
                    }
                    return str;
                } else {
                    str = str.slice(0, index + 1 + parNum);
                    return str;
                }
            }
        } else {
            //不补零
            if (value > 0) {
                //value正数
                // str = Math.floor(value * (Math.pow(10, parNum))) / Math.pow(10, parNum);
                str = this.accDiv(Math.floor(this.accMul(value,(Math.pow(10, parNum)))), Math.pow(10, parNum));
                // debugger;
                return str;
            } else {
                //value为负数
                if (parNum == 0) {
                    if (index == 0) {
                        str = str.slice(0, str.length);
                        return str;
                    } else {
                        str = str.slice(0, index + parNum);
                        if (str == '-0') {
                            str = 0;
                        }
                        return str;
                    }
                } else {
                    if (index == 0) {
                        str = str.slice(0, str.length);
                        return str;
                    } else {
                        str = str.slice(0, index + 1 + parNum);
                        str = parseFloat(str);
                        return str;
                    }
                }
            }
        }
    }

    accDiv(arg1, arg2) {
        var t1 = 0, t2 = 0, r1, r2;
        try {
            t1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
        }
        try {
            t2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
        }
        r1 = Number(arg1.toString().replace(".", ""));
        r2 = Number(arg2.toString().replace(".", ""));
        return this.accMul((r1 / r2), Math.pow(10, t2 - t1));

    }
    accMul(arg1, arg2) {
        var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length;
        }
        catch (e) {
        }
        try {
            m += s2.split(".")[1].length;
        }
        catch (e) {
        }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
    }
}


// WEBPACK FOOTER //
// ./src/pipe/subDiget.pipe.ts